import apiRequest from '@app/utils/apiRequest';

export const requestGetCddSddvList = (params) => apiRequest.get(`/candidate/cdd-sddv-list/`, {params: params});
